import { render, staticRenderFns } from "./addForm.vue?vue&type=template&id=87cefce2&scoped=true&"
import script from "./addForm.vue?vue&type=script&lang=js&"
export * from "./addForm.vue?vue&type=script&lang=js&"
import style0 from "./addForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addForm.vue?vue&type=style&index=1&id=87cefce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cefce2",
  null
  
)

export default component.exports